// Cấu hình khung ảnh.
//
// Toạ độ các ô được đo trực tiếp từ vùng trong suốt của file PNG
// (connected-component trên kênh alpha), nên khớp chính xác với lỗ trên khung.
// Mỗi khung có hình dạng lỗ riêng — khung 3 có một ô hình trái tim, khung 4
// có cả bốn ô hình trái tim. Ở đây ta chỉ lưu hình chữ nhật bao ngoài: phần
// thừa sẽ bị chính khung PNG đè lên che đi khi vẽ.

export const FRAMES = [
    {
        id: "heart-1",
        src: "/assets/frames/heart-frame.png",
        slots: [
            { x: 124, y: 86, w: 950, h: 555 },
            { x: 124, y: 686, w: 950, h: 555 },
            { x: 126, y: 1287, w: 950, h: 555 },
            { x: 126, y: 1893, w: 950, h: 555 }
        ]
    },
    {
        id: "heart-2",
        src: "/assets/frames/heart-frame-2.png",
        slots: [
            { x: 123, y: 86, w: 951, h: 556 },
            { x: 123, y: 685, w: 951, h: 556 },
            { x: 125, y: 1286, w: 951, h: 556 },
            { x: 125, y: 1893, w: 951, h: 556 }
        ]
    },
    {
        id: "heart-3",
        src: "/assets/frames/heart-frame-3.png",
        slots: [
            { x: 124, y: 86, w: 950, h: 556 },
            { x: 159, y: 682, w: 888, h: 594 },
            { x: 126, y: 1309, w: 950, h: 555 },
            { x: 124, y: 1915, w: 950, h: 556 }
        ]
    },
    {
        id: "heart-4",
        src: "/assets/frames/heart-frame-4.png",
        slots: [
            { x: 159, y: 70, w: 888, h: 595 },
            { x: 159, y: 659, w: 888, h: 595 },
            { x: 153, y: 1250, w: 888, h: 595 },
            { x: 154, y: 1850, w: 888, h: 595 }
        ]
    },
    // Các khung dưới đây được tách từ ảnh JPEG người dùng thêm vào. JPEG không có
    // kênh alpha nên vùng ô ảnh (các hình chữ nhật sáng màu) đã được khoét thành
    // trong suốt bằng PIL, toạ độ ô đo trực tiếp từ vùng vừa khoét.
    {
        // Shin-chan xanh — tách phần khung dọc bên trái của ảnh gốc (4 ô).
        id: "shinchan-1",
        src: "/assets/frames/shinchan-1.png",
        slots: [
            { x: 61, y: 90, w: 230, h: 165 },
            { x: 66, y: 282, w: 224, h: 166 },
            { x: 63, y: 475, w: 227, h: 173 },
            { x: 62, y: 675, w: 228, h: 173 }
        ]
    },
    {
        // Shin-chan đỏ — cùng bố cục, 4 ô.
        id: "shinchan-2",
        src: "/assets/frames/shinchan-2.png",
        slots: [
            { x: 64, y: 92, w: 227, h: 161 },
            { x: 68, y: 283, w: 222, h: 164 },
            { x: 66, y: 475, w: 224, h: 171 },
            { x: 63, y: 676, w: 227, h: 171 }
        ]
    },
    {
        // "Favorite Person" đỏ đô — 3 ô.
        id: "favorite-person",
        src: "/assets/frames/favorite-person.png",
        slots: [
            { x: 146, y: 38, w: 380, h: 292 },
            { x: 146, y: 356, w: 377, h: 293 },
            { x: 146, y: 677, w: 377, h: 292 }
        ]
    },
    {
        // Kate & Jackson vintage tem thư — 3 ô.
        id: "kate-jackson",
        src: "/assets/frames/kate-jackson.png",
        slots: [
            { x: 159, y: 308, w: 220, h: 167 },
            { x: 160, y: 484, w: 216, h: 164 },
            { x: 162, y: 662, w: 213, h: 162 }
        ]
    },
    {
        // Máy ảnh đỏ — 3 màn hình. Màn hình hơi nghiêng nên ô chữ nhật để lộ một
        // chút viền đen quanh mép, coi như ảnh hiển thị trên màn máy ảnh.
        id: "camera-red",
        src: "/assets/frames/camera-red.png",
        slots: [
            { x: 156, y: 219, w: 282, h: 227 },
            { x: 187, y: 557, w: 270, h: 210 },
            { x: 179, y: 888, w: 303, h: 249 }
        ]
    }
];

// Số ô mặc định của một dải, dùng khi chưa chọn khung. Số ô thật của mỗi khung
// lấy từ frame.slots.length vì các khung mới có 3 hoặc 4 ô khác nhau.
export const PHOTOS_PER_STRIP = 4;
